module.exports = __webpack_public_path__ + "img/CloseOut.a995b69c.svg";